var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "promo-stripe--skeleton m-dynamic--x" })
    : _c(
        "div",
        {
          staticClass: "promo-stripe --plp m-dynamic--x",
          class: _vm.promoStripeColorClass,
          style: _vm.backgroundStyle,
          on: { click: _vm.onPromoStripeClick },
        },
        [
          _c(
            "div",
            { staticClass: "plp-promo-stripe__copy", class: [_vm.alignText] },
            [_vm._t("default"), _vm._v(" "), _vm._t("cta_block")],
            2
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }